import TabToggle from 'components/commons/tab-toogle'
import { Button, InlineError, Input, Spinner } from 'avo-ui'
import TextEditor from 'components/commons/text-editor'

export const ReturnPolicy = ({ returnPolicyDetail, errorForm, onChangeForm, isLoading, isUpdating, onSubmit }) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <TabToggle
                        title={'General'}
                        content={
                            <div className={'flex flex-col space-y-5'}>
                                <div className={'flex flex-col space-y-3 w-1/2'}>
                                    <div className={'font-semibold text-blue-90 required'}>Title</div>
                                    <Input
                                        className={'flex-1'}
                                        name={'title'}
                                        placeholder={'Masukkan title'}
                                        value={returnPolicyDetail?.title}
                                        onChange={onChangeForm}
                                    />
                                    <InlineError className='mt-2' message={errorForm?.title} />
                                </div>
                                <div className={'flex flex-col space-y-3'}>
                                    <div className={'font-semibold text-blue-90 required'}>Description</div>
                                    <div className={'flex-1 space-y-3'}>
                                        <TextEditor
                                            className={'!h-fit'}
                                            defaultValue={returnPolicyDetail?.description || '<p></p>'}
                                            onChange={(value) => onChangeForm({ name: 'description', value })}
                                            placeholder={'Isi uraian deskripsi'}
                                        />
                                        <InlineError message={errorForm?.description} />
                                    </div>
                                </div>
                            </div>
                        }
                    />
                    <div className={'flex py-3 justify-center'}>
                        <Button className={'w-[200px]'} loading={isUpdating} title={'Submit'} onClick={onSubmit} />
                    </div>
                </>
            )}
        </div>
    )
}
